// src/components/PhotoTicker.jsx
import React, { useState, useEffect, useMemo } from "react";

const HARDCODED_PHOTOS = [
  // List 1 (FamilyPhotos)
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/FamilyPhotos/098F5E7F-541E-4DE9-9A08-05CC5B566118_1_105_c.jpeg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/FamilyPhotos/2015-12-25%2015.04.41.jpg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/FamilyPhotos/2016-12-23%2017.35.15.jpg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/FamilyPhotos/2016-12-25%2014.05.50.jpg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/FamilyPhotos/2016-12-25%2014.06.19.jpg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/FamilyPhotos/2016-12-25%2014.45.12.jpg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/FamilyPhotos/2016-12-27%2013.23.26.jpg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/FamilyPhotos/2016-12-27%2013.40.16.jpg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/FamilyPhotos/2016-12-27%2014.32.43.jpg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/FamilyPhotos/2017-11-24%2008.20.03.jpg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/FamilyPhotos/2017-11-24%2008.20.04.jpg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/FamilyPhotos/2017-12-03%2014.16.08-2.jpg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/FamilyPhotos/2017-12-25%2014.07.25.jpg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/FamilyPhotos/2017-12-25%2015.33.50.jpg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/FamilyPhotos/2017-12-25%2021.05.27.jpg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/FamilyPhotos/2017-12-25%2022.07.44.jpg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/FamilyPhotos/5001502F-252ets-49E0-A17E-FBDE1FF9C8BC_1_105_c.jpeg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/FamilyPhotos/61BF4836-F576-4B74-8CE3-C22D6E1FF79E_1_105_c.jpeg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/FamilyPhotos/64AE34B9-BCB6-4F0D-8074-D1523F6D5C60_1_105_c.jpeg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/FamilyPhotos/6F90AB73-46BA-4169-BFAF-438DC44445FF_1_105_c.jpeg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/FamilyPhotos/80A4655C-96A0-48DA-99EE-F18A32896DC2_1_105_c.jpeg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/FamilyPhotos/99449007-5E05-4A73-B400-32F02BA4F93F_1_105_c.jpeg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/FamilyPhotos/A8CBF0FF-290C-4F58-A00F-F8EE261C2E56_1_105_c.jpeg",
  // List 2 (NewFamilyPhotos)
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/NewFamilyPhotos/06A5EEB4-0504-4B38-91FA-C2580205D4B9_1_105_c.jpeg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/NewFamilyPhotos/1B32625E-C435-42BF-B8C4-9B44E23DBEE8_1_105_c.jpeg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/NewFamilyPhotos/3DCD66D2-825C-4E8E-B8D6-46EDBE82F143_1_105_c.jpeg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/NewFamilyPhotos/4C41CCC1-5057-4FA9-9210-5D4F5589210D_1_105_c.jpeg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/NewFamilyPhotos/604CBCF7-94B3-47A3-9FD9-D454ABECC453_1_105_c.jpeg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/NewFamilyPhotos/6A9D6C16-A8DD-4277-BCF7-E7E0016AE1EF_1_105_c.jpeg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/NewFamilyPhotos/81C1542F-D4BD-4B85-87CA-EC1EDAAEADAA_1_105_c.jpeg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/NewFamilyPhotos/8477B57C-D88C-43D6-A22C-83F38889E41B_1_105_c.jpeg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/NewFamilyPhotos/8D6548B6-D1ED-405D-9B6E-2EEF3390D2B0_1_105_c.jpeg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/NewFamilyPhotos/96E6EDF9-371E-47C3-93B6-E55699AF79D0_4_5005_c.jpeg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/NewFamilyPhotos/9D61C952-105A-44AF-816D-A088B2BB8CA9_1_105_c.jpeg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/NewFamilyPhotos/CC9AF0A1-5F74-4BBC-94CE-07D42997FB79_1_105_c.jpeg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/NewFamilyPhotos/E6FF5154-7E0D-432A-BCA6-3C3373B315AC_1_105_c.jpeg",
  "https://pub-7f797a603d764466b01d175f8f7182f2.r2.dev/DylanSpotifySite/NewFamilyPhotos/FAC8F570-3E31-4ACA-850F-7597D94EEC0B_1_105_c.jpeg",
];

// Worker URL
const WORKER_URL = "https://spotify-worker.benton-161.workers.dev";

export default function PhotoTicker() {
  const [selected, setSelected] = useState(null);
  const [uploadedPhotos, setUploadedPhotos] = useState([]);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await fetch(`${WORKER_URL}/photos/list`);
        if (!res.ok) return;
        const data = await res.json();
        if (mounted && Array.isArray(data.photos)) {
          setUploadedPhotos(data.photos.reverse());
        }
      } catch (e) {
        console.error("Could not fetch uploaded photos:", e);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  const allPhotos = useMemo(
    () => [...uploadedPhotos, ...HARDCODED_PHOTOS],
    [uploadedPhotos]
  );
  const displayList = useMemo(() => [...allPhotos, ...allPhotos], [allPhotos]);

  return (
    <>
      <style>{`
        /* Ticker Styles */
        @keyframes tickerScroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .ticker-wrap {
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          overflow: hidden;
          z-index: 10;
          pointer-events: none;
          padding-bottom: 20px;
          mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
          -webkit-mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
        }
        .ticker-track {
          display: flex;
          gap: 32px;
          width: max-content;
          animation: tickerScroll ${Math.max(
            120,
            displayList.length * 4
          )}s linear infinite; 
        }
        .ticker-track:hover {
          animation-play-state: paused;
        }
        .ticker-photo {
          height: 140px; 
          width: auto;
          border-radius: 8px;
          border: 4px solid #fff;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          background: #fff;
          cursor: zoom-in;
          pointer-events: auto;
          transform: rotate(var(--rot));
          transition: transform .2s ease, box-shadow .2s ease;
        }
        .ticker-photo:hover {
          transform: scale(1.1) rotate(0deg);
          z-index: 20;
          box-shadow: 0 10px 25px rgba(0,0,0,0.25);
        }

        /* View All Button */
        .view-all-btn {
          position: fixed;
          bottom: 180px; 
          right: 20px;
          z-index: 15;
          pointer-events: auto;
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          padding: 10px 20px;
          border-radius: 50px;
          border: 1px solid rgba(0,0,0,0.1);
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          font-weight: 600;
          font-size: 14px;
          color: #333;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        .view-all-btn:hover {
          transform: scale(1.05);
          background: #fff;
        }
        
        /* MASONRY GALLERY STYLES */
        .gallery-overlay {
          position: fixed;
          inset: 0;
          z-index: 90;
          background: rgba(250, 249, 246, 0.98); /* Warmer background */
          display: flex;
          flex-direction: column;
          animation: slideUp 0.3s ease-out;
        }
        .gallery-header {
          padding: 20px 40px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: rgba(255,255,255,0.8);
          backdrop-filter: blur(5px);
          border-bottom: 1px solid rgba(0,0,0,0.05);
        }
        .gallery-scroll-area {
          flex: 1;
          overflow-y: auto;
          padding: 40px;
        }
        /* The Magic Masonry Columns */
        .masonry-grid {
          column-count: 4; /* Default for desktop */
          column-gap: 24px;
        }
        @media (max-width: 1024px) { .masonry-grid { column-count: 3; } }
        @media (max-width: 768px) { .masonry-grid { column-count: 2; } }
        @media (max-width: 480px) { .masonry-grid { column-count: 1; } }

        .gallery-item {
          break-inside: avoid;
          margin-bottom: 24px;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 4px 15px rgba(0,0,0,0.08);
          transition: transform 0.2s ease, box-shadow 0.2s ease;
          cursor: zoom-in;
          background: #fff;
        }
        .gallery-item:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 30px rgba(0,0,0,0.15);
        }
        .gallery-item img {
          width: 100%;
          height: auto;
          display: block;
        }

        @keyframes slideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }
      `}</style>

      {/* 1. Ticker */}
      <div className="ticker-wrap" aria-hidden="true">
        <div className="ticker-track">
          {displayList.map((src, i) => {
            const rot = ((i * 137.508) % 6) - 3;
            return (
              <img
                key={`${src}-${i}-ticker`}
                src={src}
                alt=""
                className="ticker-photo"
                style={{ "--rot": `${rot}deg` }}
                loading="lazy"
                onClick={() => setSelected(src)}
              />
            );
          })}
        </div>
      </div>

      {/* 2. View All Button */}
      <button className="view-all-btn" onClick={() => setIsGalleryOpen(true)}>
        Open Family Gallery ↗
      </button>

      {/* 3. Masonry Gallery Overlay */}
      {isGalleryOpen && (
        <div className="gallery-overlay">
          <div className="gallery-header">
            <div>
              <h2
                style={{
                  fontSize: 22,
                  fontWeight: 700,
                  margin: 0,
                  color: "#1a1a1a",
                }}
              >
                Family Memories
              </h2>
              <span style={{ fontSize: 13, color: "#666" }}>
                {allPhotos.length} photos collected
              </span>
            </div>
            <button
              onClick={() => setIsGalleryOpen(false)}
              style={{
                padding: "8px 20px",
                borderRadius: 50,
                border: "1px solid #ddd",
                background: "#fff",
                cursor: "pointer",
                fontWeight: 600,
                color: "#333",
              }}
            >
              Close
            </button>
          </div>
          <div className="gallery-scroll-area">
            <div className="masonry-grid">
              {allPhotos.map((src, i) => (
                <div
                  key={`${src}-${i}-grid`}
                  className="gallery-item"
                  onClick={() => setSelected(src)}
                >
                  <img src={src} alt="" loading="lazy" />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* 4. Fullscreen Lightbox */}
      {selected && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 100,
            background: "rgba(0, 0, 0, 0.95)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 40,
            cursor: "zoom-out",
            animation: "fadeIn 0.2s ease-out",
          }}
          onClick={() => setSelected(null)}
        >
          <style>{`@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }`}</style>
          <img
            src={selected}
            alt="Expanded memory"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
              borderRadius: 4,
              boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
            }}
            onClick={(e) => e.stopPropagation()}
          />
          <button
            onClick={() => setSelected(null)}
            style={{
              position: "absolute",
              top: 30,
              right: 30,
              background: "rgba(255,255,255,0.2)",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: 44,
              height: 44,
              fontSize: 24,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            ×
          </button>
        </div>
      )}
    </>
  );
}
